/**
 * Teslimat durumu etiketleri — TEK kaynak.
 *
 * Anahtarlar backend `DeliveryStatus` enum'u ile birebirdir. Liste ekranı ile rapor
 * ekranı ayrı ayrı harita tutarken aynı durum iki yerde iki farklı adla yazılabiliyordu;
 * "tone" değeri de rozet renklerini iki sayfada aynı tutar.
 */
export const DELIVERY_STATUS = {
    0: { label: 'Beklemede', tone: 'pending' },
    1: { label: 'Kurye Aranıyor', tone: 'dispatching' },
    2: { label: 'Kurye Onayı Bekleniyor', tone: 'awaiting' },
    3: { label: 'Kurye Atandı', tone: 'assigned' },
    4: { label: 'Teslimat Alınıyor', tone: 'picking' },
    5: { label: 'Teslimat Alındı', tone: 'picked' },
    6: { label: 'Teslimatta', tone: 'delivering' },
    7: { label: 'Teslim Edildi', tone: 'delivered' },
    8: { label: 'Başarısız', tone: 'failed' },
    9: { label: 'İptal Edildi', tone: 'cancelled' },
    10: { label: 'Partner Hazırlıyor', tone: 'preparing' },
    11: { label: 'Yetersiz Bakiye', tone: 'insufficient-balance' },
    12: { label: 'Hazır (Alınmayı Bekliyor)', tone: 'preparing' },
};

/** Paketin daha ilerlemeyeceği durumlar. */
export const TERMINAL_STATUSES = [7, 8, 9];

/** Bilinmeyen kod için de bir etiket döner — boş hücre sayıyı okunmaz kılar. */
export function getDeliveryStatus(code) {
    return DELIVERY_STATUS[Number(code)] || { label: 'Bilinmiyor', tone: 'unknown' };
}
